import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import AISCHOOLLOGO from "assets/image/common/aischool_logo.png";
import { colors } from 'styles/global-styles';

const MainContainer = styled.section`
    width: 600px;
    height: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    color: ${({theme}) => theme.newTheme.default.textGray};
    font-size: 0.875rem;
    
    a, p {
        font-size: 12px;
    }
    main {
        min-height: 80%;
        display: flex;
        flex-direction: column;
        border-radius: 1rem;
        gap: 1.5rem;
        position: relative;

        button:not(.policy-btn) {
            width: 100%;
            font-size: 0.875rem;
            font-weight: 600;

            &:not(.login-btn) {
                margin-top: auto;
            }
        }
    }
    .title {
        font-weight: 600;
    }
    .error {
        background-color: ${colors.deleteBg};
        border-color:  ${({theme}) => theme.newTheme.default.error};
        ~ p {
            color:  ${({theme}) => theme.newTheme.default.error};
        }
    }
    .none {
        display: none;
    }
    .show {
        display: block;
    }
    .text-red {
        color: ${({theme}) => theme.newTheme.default.error};
        margin-top: 2.25rem;
    }
    .eye-on-off {
        display: inline-flex;
        position: absolute;
        top: 2rem;
        right: 1rem;
        width: 2rem;
        aspect-ratio: 1 / 1;
        color: ${({theme}) => theme.newTheme.text.btnText_disabled};
    }
    .tip {
        padding: 0.625rem 1.25rem;
        border-bottom: 1px solid ${({ theme }) => theme.newTheme.border.primaryBd};
        
        &:hover {
            cursor: pointer;
            opacity: 0.6;
        }
    }
`;

export let pathName = "";
export let checkLoginPage = true;
const regex = /^\/login\/?$/g;

function LoginWrap() {
    const location = useLocation();
    pathName = location.pathname;
    checkLoginPage = regex.test(pathName); // true면 로그인페이지 false면 회원가입페이지

    return (
        <MainContainer>
            <figure>
                <img src={AISCHOOLLOGO} alt="logo" style={{height: "30px"}}/>
            </figure>
            <Outlet />
        </MainContainer>
    );
}

export default LoginWrap;